import { useState } from 'react';

import { faPrint } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@repo/videa-components/src/index';
import { isToday } from 'date-fns';
import { useAtom, useAtomValue } from 'jotai';

import { modeAtom, selectDateAtom } from '../../../modules/patientList/atoms';
import type { Appointment } from '../../../react-query/useAppointments';
import type { GetTaskResponse } from '../../../react-query/useGetTasks';
import type { TVisitSummary } from '../../../react-query/useVisitSummaries';
import { mixpanelEvents, useTrackEvent } from '../../../utils/mixpanel';

import { PrintDownloadDialog } from './PrintDownloadDialog';

interface Props {
  appointmentIdsToTasks: Record<string, GetTaskResponse>;
  appointments: Appointment[];
  visitSummaries?: TVisitSummary[];
}

export const PrintButton = ({
  appointmentIdsToTasks,
  appointments,
  visitSummaries,
}: Props) => {
  // atoms
  const [selectedDate] = useAtom(selectDateAtom);
  const mode = useAtomValue(modeAtom);

  // state
  const [isOpen, setIsOpen] = useState(false);
  const { trackEvent } = useTrackEvent();

  const handleClickPrintIcon = () => {
    trackEvent(mixpanelEvents.huddlePrint, {
      selectedHuddleDate: selectedDate,
      selectedView: mode,
      source: 'patientListPrint',
      date: selectedDate,
      isToday: selectedDate ? isToday(selectedDate) : false,
    });
    setIsOpen(true);
  };

  if (mode === 'RECENT_VISITS' || !selectedDate) return null;

  return (
    <>
      <Button
        className="vai-w-9 vai-h-9"
        size="icon"
        variant="ghostIcon"
        onClick={handleClickPrintIcon}
        data-testid="printout-button"
      >
        <FontAwesomeIcon icon={faPrint} />
      </Button>

      <PrintDownloadDialog
        appointmentIdsToTasks={appointmentIdsToTasks}
        appointments={appointments}
        visitSummaries={visitSummaries}
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
      />
    </>
  );
};
